import { Browser } from "../utils/Browser";
export class _WebSocket {
    open(url, options) {
        let protocols = options === null || options === void 0 ? void 0 : options.protocols;
        if (!protocols || protocols.length == 0)
            this.ws = new Browser.window.WebSocket(url);
        else
            this.ws = new Browser.window.WebSocket(url, protocols);
        this.ws.binaryType = "arraybuffer";
        this.ws.onopen = e => this.onOpen({});
        this.ws.onclose = e => this.onClose();
        this.ws.onerror = err => this.onError(err);
        this.ws.onmessage = msg => {
            if (msg.data)
                this.onMessage(msg.data);
        };
    }
    close() {
        this.ws.close();
    }
    send(data) {
        this.ws.send(data);
        return Promise.resolve();
    }
}
